import {
  CheckCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/20/solid";
import { siteSettings } from "../../settings";

export default function TermsText() {
  return (
    <div className="bg-white px-6 py-32 lg:px-8">
      <div className="mx-auto max-w-4xl text-base leading-7 text-gray-700">
        {/* <p className="text-base font-semibold leading-7 text-indigo-600">
              Introducing
            </p> */}
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Our terms of fair usage and service
        </h1>
        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Introduction
          </h2>
          <p className="mt-6">
            This Agreement is entered into by and between Prime Alliance LTD
            (hereinafter referred to as the "Company") and the user (a natural
            or legal entity) (hereinafter referred to as the "Client"). By
            accessing or registering an Account on primealliancepro.com (the
            "Website"), the Client agrees to comply with all the terms and
            conditions outlined in this Agreement and any associated policies,
            including but not limited to the Privacy Policy, Payment Policy,
            Withdrawal Policy, Code of Conduct, Order Execution Policy, and
            Anti-Money Laundering (AML) Policy. Acceptance of these terms
            constitutes a legally binding agreement between the Client and the
            Company, regulating the use of the Company's Trading Platform and
            services.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Terms
          </h2>
          <p className="mt-6">
            • Account: A unique, personalized account registered in the Client's
            name, storing all transactions, operations, and activities conducted
            on the Trading Platform.
            <br />
            • Trading Platform: The electronic system provided by the Company
            that facilitates real-time trading, quote displays, and order
            management.
            <br />
            • Copy Trading: A feature enabling the Client to replicate the
            trading strategies of other users on the platform.
            <br />
            • Staking: The process of locking cryptocurrency assets to earn
            rewards under specified conditions and APY rates.
            <br />
            • COT (Cost of Transfer): Variable fees impacting the withdrawal
            process, determined by factors such as blockchain traffic and
            third-party charges.
            <br />
            • KYC Documents: Identification and verification documents,
            including but not limited to passports, government IDs, and proof of
            residence, required for regulatory compliance.
            <br />
            • Spread: The difference between the Ask (buy) and Bid (sell) prices
            for a financial instrument at the same moment.
            <br />• Financial Instruments: Tradeable instruments defined under
            applicable regulatory standards and offered through the Company's
            Trading Platform.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Regulatory Compliance
          </h2>
          <p className="mt-6">
            The Company operates under regulatory compliance standards set by
            the United States, European Union, and Australia. The Client agrees
            to adhere to all applicable local and international regulations and
            laws governing financial transactions and trading practices.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Subject Of The Agreement
          </h2>
          <p className="mt-6">
            The Company provides access to financial trading, cryptocurrency
            staking, and related services through its Trading Platform on an
            execution-only basis. The Client acknowledges that the Company does
            not manage or offer advisory services for the Client's account, nor
            does it bear responsibility for the outcome of any trading decisions
            made by the Client. All activities conducted on the Trading Platform
            are subject to the terms of this Agreement and relevant
            documentation published on the Website.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            General Provisions
          </h2>
          <p className="mt-6">
            <strong>Service Scope</strong>
            <br />
            The Company shall offer services at its discretion, including, but
            not limited to:
            <br />
            • Access to real-time trading and execution of orders.
            <br />
            • Copy trading services that facilitate the duplication of other
            traders' activities.
            <br />
            • Cryptocurrency staking and conversion services.
            <br />
            • Access to news, analytics, and trading data.
            <br />
            The Client acknowledges that services provided by the Company do not
            include investment advice, portfolio management, or guaranteed
            returns.
            <br />
            <br />
            <strong>Deposit Allocation</strong>
            <br />
            • Specific Allocation: All deposits made by the Client must be
            clearly allocated to their respective sections (e.g., investment
            plans or signal purchases). Misallocations are prohibited and may
            require administrative adjustments, which could incur additional
            fees.
            <br />
            • Collateral Provision: Deposited funds are considered collateral
            that the Client provides to secure obligations to the Company.
            <br />
            <br />
            <strong>User Conduct and Restrictions</strong>
            <br />
            • The Client shall not engage in activities that breach the
            security, integrity, or operation of the Trading Platform.
            <br />• The Client is prohibited from executing transactions that
            exceed their available Account balance or plan. Such actions may
            result in penalties, suspension, or permanent account termination.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Account Types and User Privileges
          </h2>
          <p className="mt-6">
            The Company offers a tiered account system that progresses in
            conjunction with the Client's investment plan. Each account type has
            an associated profit threshold/cap, determining the Client's
            eligibility for an investment plan upgrade. The details for each
            account plan are as follows:
            <br />
            <br />
            <strong>Starter Account</strong>
            <br />
            • Profit Threshold: $99,999.99
            <br />
            • Trading Features: Basic stock pair trading & limited copy trading.
            <br />
            • Staking Options: Limited staking options with lower APY (3.5% -
            5.0% APY).
            <br />
            • Support Level: Live chat & email support (slower response times).
            <br />
            • Fees: Standard trading & staking fees.
            <br />
            • Best for: New investors looking for an entry-level plan with
            flexibility.
            <br />
            <br />
            <strong>Silver Account</strong>
            <br />
            • Profit Threshold: $179,999.99
            <br />
            • Trading Features: Expanded trading access to more stock pairs &
            enhanced copy trading.
            <br />
            • Staking Options: Wider staking options with improved APY (5.5% -
            7.0% APY).
            <br />
            • Support Level: Enhanced email support with moderately faster
            response times.
            <br />
            • Fees: Reduced trading & staking fees.
            <br />
            <strong>Exclusive Benefits</strong>
            <br />
            • Occasional early access to new platform features.
            <br />
            • Best for: Investors looking for more diversified opportunities and
            improved returns.
            <br />
            <br />
            <strong>Gold Account</strong>
            <br />
            • Profit Threshold: $349,999.99
            <br />
            • Trading Features: Full access to all stock pairs & comprehensive
            copy trading metrics.
            <br />
            • Staking Options: Premium staking options with flexible terms &
            higher APY (7.5% - 9.0% APY).
            <br />
            • Support Level: Priority email & live chat support.
            <br />
            • Fees: Further reduced trading & staking fees.
            <br />
            <strong>Exclusive Benefits (Compared to Silver Plan)</strong>
            <br />
            • Expedited withdrawal processing.
            <br />
            • Access to quarterly investment reports.
            <br />
            • Best for: Investors looking for higher-value trades and priority
            support.
            <br />
            <br />
            <strong>Premium Account</strong>
            <br />
            • Profit Threshold: $549,999.99
            <br />
            • Trading Features: Full platform access, including advanced copy
            trading with real-time syncing.
            <br />
            • Staking Options: Access to high-priority staking with top APY
            rates (9.5% - 12.0% APY).
            <br />
            • Support Level: 24/7 live chat, email & phone support.
            <br />
            • Fees: Preferential fee structures with the lowest trading &
            staking charges.
            <br />
            • Educational Resources: Exclusive access to webinars, courses, and
            expert-led workshops.
            <br />
            <strong>Exclusive Benefits</strong>
            <br />
            • Dedicated account manager for personalized trading assistance.
            <br />
            • VIP event invitations for investment insights.
            <br />
            • Highest withdrawal limits and expedited processing.
            <br />
            • Best for: High-net-worth investors and experienced traders seeking
            maximum benefits.
            <br />
            <br />
            <strong>Platinum Account</strong>
            <br />
            • Profit Threshold: $999,999.99+ (awarded based on account
            activities).
            <br />
            • Trading Features: Unlimited access to proprietary tools, advanced
            charting, and AI-powered analytics.
            <br />
            • Copy Trading: Exclusive access with unique features such as
            revenue-sharing for top traders and customizable strategy execution.
            <br />
            • Staking Options: VIP access to top-tier staking programs with
            flexible terms and the highest APY available, plus priority
            allocation in limited staking pools (12.5% - 15.0% APY).
            <br />
            • Support Level: Concierge-level, 24/7 white-glove service with a
            dedicated personal manager and priority response across all support
            channels.
            <br />
            • Fees: Zero trading fees and access to special loyalty incentives,
            rebates, and custom fee structures.
            <br />
            • Educational Resources: Personalized training programs, one-on-one
            mentorship, and invitation-only seminars with top industry experts.
            <br />
            • Portfolio Management: Exclusive investment consultation services,
            including custom risk analysis and portfolio optimization
            strategies.
            <br />
            <strong>Exclusive Benefits</strong>
            <br />
            • Invitations to elite networking events with industry leaders.
            <br />
            • Private market insights and early access to premium investment
            opportunities.
            <br />
            • Closed beta program access for testing new platform features
            before public release.
            <br />
            • Co-development opportunities to influence future trading tools and
            platform enhancements.
            <br />
            • Priority withdrawal processing with no limits and same-day
            execution.
            <br />
            • Access to exclusive hedge fund partnerships and premium venture
            capital opportunities.
            <br />• Best for: High-performing traders and investors with the
            largest portfolios, seeking unparalleled market access, exclusive
            perks, and the highest level of service.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Execution of Orders / Electronic Trading
          </h2>
          <p className="mt-6">
            The Client acknowledges that all orders will be executed by the
            Company as a counterparty. The Company acts as a principal, not an
            agent, for these transactions. Orders are processed sequentially and
            promptly unless technical or market-related issues arise. The
            Company is not responsible for unauthorized use of the Client's
            Account or for errors due to mechanical failures, except in cases of
            gross negligence or fraud by the Company.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Charges and Fees
          </h2>
          <p className="mt-6">
            <strong>General Fee Structure</strong>
            <br />
            The Company reserves the right to charge fees for services,
            including but not limited to:
            <br />
            • Service Fees: Standard charges for accessing trading and staking
            services.
            <br />
            • COT (Cost of Transfer): Variable fees that depend on withdrawal
            criteria such as blockchain congestion and transaction size.
            <br />
            • Third-party Fees: Charges related to third-party service
            providers.
            <br />
            • Regulatory Compliance Costs: Fees for necessary verification and
            compliance checks.
            <br />
            <br />
            <strong>Staking and Conversion Fees</strong>
            <br />
            • Staking Fees: A fixed fee of 1.25% on the total staked amount.
            <br />
            • Conversion Fees: Free of charge for currency conversions within
            the platform.
            <br />
            <br />
            <strong>Changes to Fees</strong>
            <br />
            The Company may revise its fee structure and will notify Clients of
            such changes via the Website or email. Continued use of the services
            implies acceptance of the new fees.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Withdrawal Policy
          </h2>
          <p className="mt-6">
            <strong>General Withdrawal Terms</strong>
            <br />
            Withdrawals cannot be initiated while there are active trade
            positions in the Client's Account.
            <br />
            <br />
            <strong>Processing Time and Criteria</strong>
            <br />
            Standard processing for withdrawal requests is up to 3 business
            days, influenced by factors such as blockchain traffic and
            withdrawal size.
            <br />
            <br />
            <strong>Withdrawal Fees</strong>
            <br />
            The Client is responsible for all withdrawal-related fees. These
            fees must be settled at the time of the request.
            <br />
            <br />
            <strong>Withdrawal Holds</strong>
            <br />
            For compliance and security reasons, certain withdrawal requests may
            be subject to review and may be temporarily held for verification
            purposes.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Investment Plan Limitations
          </h2>
          <p className="mt-6">
            <strong>Profit Thresholds</strong>
            <br />
            The four investment plan tiers has defined profit thresholds. If the
            Client's total portfolio profits exceed these thresholds (as
            specified in Section 6), the account may be temporarily suspended,
            with a notification to upgrade the plan or make adjustments.
            <br />
            <br />
            <strong>
              Investment Plan Trading Balance and Withdrawal Policy
            </strong>
            <br />
            When a Client subscribes to an investment plan, the capital
            allocated to the plan, along with accumulated profits, is
            automatically compounded for the duration of the investment term.
            This ensures the effective execution of the trading strategy. As a
            result, the running/trading balance within an active investment plan
            is locked and cannot be withdrawn until the investment term is
            completed.
            <br />
            <br />
            However, funds that are not allocated to an investment plan remain
            available for withdrawal at any time. For example, if a Client has a
            total balance of $100,000 in their trading account and subscribes to
            an investment plan with $50,000, the remaining $50,000 is available
            for withdrawal. This withdrawal balance is displayed in the
            Investment Plan Subscription Balance section within the "Invest"
            plan dashboard.
            <br />
            <br />
            <strong>Non-Compliance Penalties</strong>
            <br />
            Clients who exceed their investment plan's profit cap will receive
            notifications detailing necessary actions, including potential
            penalties or suspension until compliance is achieved.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Signal Purchase Terms and Conditions
          </h2>
          <p className="mt-6">
            <strong>Leverage Limits and Compliance</strong>
            <br />
            Each signal plan includes a pre-set leverage range. The Client
            agrees not to open trades that exceed these leverage limits.
            Violating these limits will result in temporary account suspension
            and prompts to upgrade the signal plan for compliance.
            <br />
            <br />
            <strong>Signal Plans: Leverage Range and Signal Strength</strong>
            <br />
            Prime Alliance provides 10 distinct Signal Plans, each with a
            designated leverage range and signal strength contribution:
          </p>
          <div className="mt-6">
            {(() => {
              const data = [
                { plan: "Steady Gains", leverage: "2x", strength: "8%" },
                { plan: "Momentum Master", leverage: "2x–3x", strength: "13%" },
                { plan: "Alpha Surge", leverage: "2x–4x", strength: "20%" },
                { plan: "Profit Pulse", leverage: "2x–6x", strength: "25%" },
                { plan: "QuickStrike", leverage: "2x–9x", strength: "30%" },
                {
                  plan: "Precision Trades",
                  leverage: "2x–11x",
                  strength: "40%",
                },
                { plan: "Value Vault", leverage: "2x–13x", strength: "50%" },
                {
                  plan: "Growth Catalyst",
                  leverage: "2x–15x",
                  strength: "60%",
                },
                {
                  plan: "Dividend Diligence",
                  leverage: "2x–17x",
                  strength: "80%",
                },
                { plan: "Trend Trader", leverage: "2x–20x", strength: "100%" },
              ];
              return (
                <table className="min-w-full border border-gray-700">
                  <thead>
                    <tr className="bg-gray-900 text-left">
                      <th className="p-3 border border-gray-700 text-white">
                        Signal Plan
                      </th>
                      <th className="p-3 border border-gray-700 text-white">
                        Leverage Range
                      </th>
                      <th className="p-3 border border-gray-700 text-white">
                        Signal Strength Addition
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index} className="border border-gray-700">
                        <td className="p-3 border border-gray-700">
                          {item.plan}
                        </td>
                        <td className="p-3 border border-gray-700">
                          {item.leverage}
                        </td>
                        <td className="p-3 border border-gray-700">
                          {item.strength}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            })()}
          </div>
          <p className="mt-6">
            • Leverage Range: Defines the maximum allowable leverage under each
            Signal Plan. Higher leverage allows increased exposure to the market
            but also amplifies risks.
            <br />
            <br />
            • Signal Strength: Represents the percentage increase in overall
            trading signals when a new plan is purchased. Signal strength
            accumulates when multiple plans are acquired, enhancing trading
            signals.
            <br />
            <br />
            • Third-party Fees: Charges related to third-party service
            providers.
            <br />
            <br />• Upgrading Signal Plans: Users can purchase additional signal
            plans to increase their overall signal strength, which improves the
            effectiveness of trading signals.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Consequences of Non-Compliance
          </h2>
          <p className="mt-6">
            Violations may attract a violation fee and repeated violations may
            result in account suspension or permanent account restrictions.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Limitation Of Liability
          </h2>
          <p className="mt-6">
            The Company does not guarantee uninterrupted, error-free services
            and disclaims liability for service disruptions due to external
            factors, including but not limited to third-party failures or force
            majeure events. Liability for direct or indirect damages shall not
            exceed the amount of funds deposited by the Client, except in cases
            of gross negligence or fraudulent actions by the Company.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Indemnity and Liability
          </h2>
          <p className="mt-6">
            <strong>Client Indemnification</strong>
            <br />
            The Client agrees to indemnify and hold harmless the Company, its
            directors, officers, employees, and representatives against any
            direct or indirect liabilities, losses, damages, claims, or expenses
            incurred as a result of the Client's actions or omissions in
            violation of this Agreement or related to the liquidation of
            financial instruments. This indemnity extends beyond the termination
            of the Agreement.
            <br />
            <br />
            <strong>Company's Limited Liability</strong>
            <br />
            The Company shall not be liable for any direct or indirect losses,
            including loss of profit, trading opportunity, or any incidental,
            consequential, or special damages arising from the use of the
            Trading Platform, except in cases of proven gross negligence or
            willful misconduct by the Company.
            <br />
            <br />
            <strong>Third-Party Service Liability</strong>
            <br />
            The Company shall not be held responsible for actions, omissions, or
            failures of third-party service providers, including payment
            processors, custodians, and other intermediaries involved in
            transactions on behalf of the Client.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Personal Data Protection
          </h2>
          <p className="mt-6">
            <strong>Data Collection and Usage</strong>
            <br />
            By accepting this Agreement, the Client consents to the collection,
            storage, and processing of personal data, which includes but is not
            limited to names, contact details, transaction history, and IP
            addresses. The Company collects this information to comply with
            regulatory requirements, facilitate transactions, and improve
            services.
            <br />
            <br />
            <strong>Data Security</strong>
            <br />
            The Company shall implement legal, organizational, and technical
            measures to protect the Client's personal data against unauthorized
            access, loss, or alteration. Data will be retained for at least 5
            years after the termination of the Agreement to meet regulatory
            obligations.
            <br />
            <br />
            <strong>Third-Party Sharing</strong>
            <br />
            The Company may share personal data with third parties solely for
            processing transactions or complying with legal obligations,
            provided that these parties agree to protect the confidentiality and
            security of the data.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Duration and Termination of the Agreement
          </h2>
          <p className="mt-6">
            <strong>Indefinite Duration</strong>
            <br />
            This Agreement shall remain in effect for an indefinite period from
            the date of acceptance and activation of the Client's Account.
            <br />
            <br />
            <strong>Termination by the Client</strong>
            <br />
            The Client may terminate this Agreement at any time by notifying the
            Company in writing and withdrawing any remaining balance in their
            Account, subject to compliance checks and applicable fees.
            <br />
            <br />
            <strong>Termination by the Company</strong>
            <br />
            The Company reserves the right to terminate the Agreement or suspend
            services with immediate effect if the Client fails to meet
            regulatory requirements, breaches any term of this Agreement, or is
            involved in fraudulent activities.
            <br />
            <br />
            <strong>Effect of Termination</strong>
            <br />
            Upon termination, the Client's access to the Trading Platform will
            be revoked, and any pending transactions will be cancelled. The
            Company will remit any remaining balance, minus applicable fees and
            unresolved liabilities.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Dispute Resolution
          </h2>
          <p className="mt-6">
            <strong>Jurisdictional Guidelines</strong>
            <br />
            Disputes involving Clients based in the U.S., EU, or Australia shall
            be resolved according to the laws and courts of the Client's country
            of residence. Clients residing outside these jurisdictions agree to
            submit to the exclusive jurisdiction of the New York State Supreme
            Court.
            <br />
            <br />
            <strong>Arbitration Option</strong>
            <br />
            For certain disputes, the Company reserves the right to propose
            resolution through binding arbitration, conducted in accordance with
            the rules of an agreed-upon arbitration body.
          </p>
        </div>

        <div>
          <h2 className="mt-16 text-2xl font-[600] tracking-tight text-gray-900">
            Technical Failures
          </h2>
          <p className="mt-6">
            The Client acknowledges that technical failures, including system
            outages or disruptions due to hardware, software, or communication
            issues, may occur. In such cases, the Company shall make reasonable
            efforts to resolve issues swiftly but shall not be held liable for
            trading interruptions or loss of data.
          </p>
        </div>

        {/* <div className="mt-10 max-w-4xl">
          
          </div> */}

        {/* <div className="mt-16 max-w-2xl">
            <h2 className="text-2xl font-[600] tracking-tight text-gray-900">
              Everything you need to get up and running
            </h2>
            <p className="mt-6">
              This Privacy Policy (the "Policy" ) applies to Brass Technologies
              Limited's online interface (i.e., website or mobile application) and
              any Brass Invoicing Limited's affiliate, subsidiary or online
              interface that is linked to this Policy, (individually referred to
              as a "site", and, collectively, "sites" ). The term "the company" or
              "Brass" or "we" or "us" or "our" in this Policy shall refer to Brass
              Invoicing Limited, and any banking and non-banking affiliates or
              subsidiaries of Brass Invoicing Limited that is linked to this
              Policy. This Policy describes how the Sites may collect, use, and
              share information from or about you, and explains how information
              may be collected and used for advertising purposes.
            </p>
            <p className="mt-8">
              Brass takes the privacy of your information very seriously. This
              Policy explains how and for what purposes we may use the information
              collected from you via the Site.
            </p>
  
            <p className="mt-8">
              Additional information on our Privacy Policy may be found on our
              Sites and within Frequently Asked Questions (FAQs) as set out on the
              Sites.
            </p>
  
            <p className="mt-8">
              Please read this Policy carefully. By using the Site and any
              services we offer via the Site, you are agreeing to be bound by this
              Policy with respect to the information collected about you via this
              Site.
            </p>
  
            <p className="mt-8">
              You may use the Site only for lawful purposes. You may not use the
              Site:
            </p>
  
            <ul>
              <li>
                In any way that breaches any applicable local, national or
                international law or regulation.
              </li>
            </ul>
          </div> */}

        {/* <div className="mt-16 max-w-2xl">
            <h2 className="text-2xl font-[600] tracking-tight text-gray-900">
              Everything you need to get up and running
            </h2>
            <p className="mt-6">
              Purus morbi dignissim senectus mattis adipiscing. Amet, massa quam
              varius orci dapibus volutpat cras. In amet eu ridiculus leo sodales
              cursus tristique. Tincidunt sed tempus ut viverra ridiculus non
              molestie. Gravida quis fringilla amet eget dui tempor dignissim.
              Facilisis auctor venenatis varius nunc, congue erat ac. Cras
              fermentum convallis quam.
            </p>
            <p className="mt-8">
              Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
              enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
              praesent donec est. Odio penatibus risus viverra tellus varius sit
              neque erat velit.
            </p>
          </div> */}
      </div>
    </div>
  );
}
